import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export interface ClaimResult {
  ok: boolean;
  reason?: string;
  reward_xp?: number;
  day_index?: number;
  current_streak: number;
  best_streak: number;
  badge_unlocked?: boolean;
  reset?: boolean;
  next_claim_at?: string;
}

export interface StreakRow {
  current_streak: number;
  best_streak: number;
  last_claim_at: string | null;
  world_cup_committed_fan: boolean;
}

export interface TopStreakRow {
  user_id: string;
  display_name: string;
  avatar_url: string | null;
  current_streak: number;
  best_streak: number;
  committed_fan: boolean;
}

export const getMyStreak = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }): Promise<StreakRow> => {
    const { supabase, userId } = context;
    const { data, error } = await supabase
      .from("daily_streaks")
      .select("current_streak, best_streak, last_claim_at, world_cup_committed_fan")
      .eq("user_id", userId)
      .maybeSingle();
    if (error) throw new Error(error.message);
    return (
      (data as StreakRow | null) ?? {
        current_streak: 0,
        best_streak: 0,
        last_claim_at: null,
        world_cup_committed_fan: false,
      }
    );
  });

export const claimDailyStreak = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }): Promise<ClaimResult> => {
    const { supabase } = context;
    const { data, error } = await supabase.rpc("claim_daily_streak");
    if (error) throw new Error(error.message);
    return data as unknown as ClaimResult;
  });

export const getTopStreaks = createServerFn({ method: "GET" })
  .handler(async (): Promise<TopStreakRow[]> => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data, error } = await supabaseAdmin.rpc("top_streaks", { _limit: 100 });
    if (error) throw new Error(error.message);
    return (data ?? []) as TopStreakRow[];
  });